import * as React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import units from 'ha/theme/units';
import { withIntl, IntlProps } from 'ha/i18n';

interface Props {
  hasAlert: boolean;
}

const styles = createStyles({
  body: {
    marginTop: units.rem(1),
  },
});

export const SearchAlertConfirmation: React.SFC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({ classes, hasAlert, intl: { T } }) => (
  <React.Fragment>
    <Typography variant="title" color={hasAlert ? 'secondary' : undefined}>
      {hasAlert
        ? T('search_alert_update_confirmation_title')
        : T('search_alert_create_confirmation_title')}
    </Typography>
    <Typography variant="body2" className={classes.body}>
      {hasAlert
        ? T('search_alert_update_confirmation_text')
        : T('search_alert_create_confirmation_text')}
    </Typography>
  </React.Fragment>
);

export default withIntl(withStyles(styles)(SearchAlertConfirmation));
